import React from 'react';

const MultiSelectResultSet = ({id, selectValue, selectLabel, onClear, onRemove, readOnly}) => {

  if(selectValue&&selectValue.length>0){
    return (<div id={`answerblock-${id}`} className='resultContainer'>
      <div className='cb-tag-set cb-btn-row result' id={`multiselectResult-${id}`} role='region' aria-label={`Applied Value for ${selectLabel}`}>
      {selectValue?.map((el,index)=>(
        <a role="button" class="cb-btn cb-btn-tag" onClick={(event)=>onRemove(el, event)} 
        style={readOnly?{pointerEvents:'none', color:'#888888'}:{}}
        href='#' key={`${id}-${index}`}
        id={`tag-${id}-${index}`}>
        <span> {el} </span>
        <span class="cb-icon cb-x-mark">
          <span class="sr-only">Remove</span>
        </span>
      </a>
      ))}
      </div>
    
      <span>
        <button type="button"  onClick={(event)=>{onClear(event, `clear-${id}`)}} id={`clear-${id}`} style={readOnly?{pointerEvents:'none'}:{}} className="cb-btn cb-btn-card-secondary">
          <span className='link'>Clear</span>
        </button>
      </span>

    </div>
    )}
    else return (<></>);
  }

export default MultiSelectResultSet